import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HashService {

  /** Перевод строки в хэш */
  hash(text: string): number {
    let h = 0;
    for (let i = 0; i < text.length; i++) {
      h = text.charCodeAt(i) + ((h << 5) - h);
      h |= 0;
    }
    return Math.abs(h);
  }

  /** Перевод строки в HSL (0-359) */
  hue(text: string): number {
    return this.hash(text) % 360;
  }

  /** CSS-цвет аватара */
  avatarColor(text: string): string {
    return `hsl(${this.hue(text)}, 70%, 40%)`;
  }

  /** Тень кольца вокруг аватара */
  avatarRingShadow(text: string): string {
    const h = this.hue(text);
    return `0 0 0 3px var(--surface), 0 0 0 6px hsl(${h}, 55%, 42%), 0 8px 22px rgba(16,24,40,.20)`;
  }

  /** Градиент шкалы баллов */
  scoreMeterGradient(text: string): string {
    const h = this.hue(text);
    return `linear-gradient(90deg, hsl(${h}, 55%, 60%), hsl(${h}, 65%, 42%))`;
  }
}
